import getHumanFileSize from './getHumanFileSize';
import capitalize from './capitalize';
import placeholders from '../../data/placeholders';
import dashToCamelCase from './dashToCamelCase';
import camelCaseToDash from './camelCaseToDash';
import camelCaseToWords from './camelCaseToWords';
import getStringBetweenParentheses from './getStringBetweenParentheses';
export default {
  camelCaseToWords: camelCaseToWords,
  getHumanFileSize: getHumanFileSize,
  capitalize: capitalize,
  placeholders: placeholders,
  camelCaseToDash: camelCaseToDash,
  dashToCamelCase: dashToCamelCase,
  getStringBetweenParentheses: getStringBetweenParentheses
};